<template>
  <v-container fluid class="home pa-0">
    <v-row class="ma-0">
      <v-col class="banner-col pa-0">
        <div class="banner"
             :style="'height:' + (pageWidth>1800?(pageWidth/28):pageWidth>1600?(pageWidth/26):pageWidth>1400?(pageWidth/24):pageWidth>1200?(pageWidth/22):(pageWidth/61 + 30)) +'vh'"></div>
        <div class="banner-description-container">
          <v-container fluid class="desc-content">
            <v-icon dark class="banner-description-icon" size="30">mdi-cards-diamond</v-icon>
            <v-row class="banner-description-category font-size-40 text-center">
              <v-col v-html="$t('home.text_1')"></v-col>
            </v-row>
            <v-row class="banner-description-title font-size-100 text-center">
              <v-col v-html="$t('home.text_2')"></v-col>
            </v-row>
            <v-row class="banner-description-description font-size-45 text-center">
              <v-col v-html="$t('home.text_3')"></v-col>
            </v-row>
            <v-row class="banner-description-button">
              <v-col class="text-center">
                <v-btn rounded
                       color="white"
                       @click="$router.push({name:'Register'})">
                  {{ $t('home.register') }}
                </v-btn>
              </v-col>
              <v-col class="text-center">
                <v-btn rounded
                       color="white"
                       @click="$router.push({name:'CheckStatus'})">
                  {{ $t('home.check_status') }}
                </v-btn>
              </v-col>
            </v-row>
            <!--            <v-row v-if="!isLoggedIn" class="banner-description-description font-size-45 text-center">-->
            <!--              <v-col v-html="$t('pre_reg.text_3')"></v-col>-->
            <!--            </v-row>-->
            <!--            <v-row v-if="!isLoggedIn" class="banner-description-button">-->
            <!--              <v-col class="text-center">-->
            <!--                <v-btn rounded-->
            <!--                       color="white"-->
            <!--                       @click="$router.push({name:'register'})">-->
            <!--                  {{ $t('pre_reg.join_now') }}-->
            <!--                </v-btn>-->
            <!--              </v-col>-->
            <!--            </v-row>-->
          </v-container>
        </div>
      </v-col>
    </v-row>
    <div class="about-acc-map-container">
      <div class="map-wrapper">
        <div class="map"></div>
      </div>
      <div class="map-description-wrapper">
        <div class="map-description">
          <div class="map-title title-font">
            {{ $t('home.map_and_location') }}
          </div>
          <div class="map-content" v-html="$t('home.map_and_location_content')"></div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import {computed} from '@vue/composition-api';

export default {
  name: 'Home',
  setup(props, {root}) {
    const pageWidth = computed(() => root.$vuetify.breakpoint.width);

    return {
      pageWidth,
    }
  }
}
</script>

<style lang="less">
.home {
  .banner-col {
    position: relative;

    .banner {
      background-image: url('../assets/canteen_home.png');
      background-size: cover;
      background-position: top;
      background-repeat: no-repeat;

      width: 100%;
      // padding-top: 48%;
      height: 40vh;
      overflow: hidden;
    }

    .banner-description-container {
      width: 100%;
      display: flex;
      color: white;
      font-family: 'Montserrat', "PingFang TC", "Heiti TC", "微軟正黑體", "Microsoft JhengHei", "sans-serif" !important;

      .desc-content {
        background-color: rgba(157, 127, 95, 1);
        width: 100%;
        padding: 0% 5% 2% 5%;
      }

      .banner-description-icon {
        /*margin-top: -10.5%;*/
        display: none;
        top: 0.75%;
        position: absolute;
        left: 0;
        transform: translateY(-50%);
      }

      .banner-description-category {
        font-size: 0.9rem;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        margin-top: 12px;
        line-height: 1.2;
      }

      .banner-description-title {
        font-weight: 400;
        font-size: 1.8rem;
        color: rgba(255, 255, 255, 1);
        line-height: 1.1;
      }

      .banner-description-description {
        font-family: Roboto, "PingFang TC", "Heiti TC", "微軟正黑體", "Microsoft JhengHei", "sans-serif" !important;
        color: rgba(255, 255, 255, 1);
        margin: 1% 0%;
        font-size: 0.85rem;
        overflow: visible;
      }

      .banner-description-button {
        font-family: Roboto, "PingFang TC", "Heiti TC", "微軟正黑體", "Microsoft JhengHei", "sans-serif" !important;

        .v-btn {
        }

        .v-btn__content {
          color: rgba(157, 127, 95, 0.8);
          margin: 0.5rem 1rem;
        }
      }

      @media only screen and (min-width: 1200px) {
        position: absolute;
        bottom: 0;
        width: 50% !important;
        justify-content: flex-end;

        .banner-description-category {
          font-size: 1.2rem;
          margin-top: 8px;
          line-height: 1.1;
        }

        .banner-description-title {
          font-size: 2.4rem;
          color: rgba(255, 255, 255, 1);
          line-height: 1.2;
        }

        .banner-description-description {
          font-size: 0.9rem;
          overflow: visible;
        }

        .banner-description-button {
          margin-top: 0.9rem;
          margin-bottom: 0.9rem;

          .v-btn {
            height: 2rem;
          }

          .v-btn__content {
            margin: 0.4rem 0.8rem;
          }
        }

        .desc-content {
          /*margin-right: 2.3% !important;*/
          width: 78.8% !important;
          position: relative;
          align-items: center;
          justify-content: center;
          background-color: rgba(156, 131, 98, 0.75) !important;
          padding: 2% 0% !important;
        }

        .banner-description-icon {
          width: 100%;
          display: flex !important;
          justify-content: center;
          /*transform: translateY(-170%);*/
        }
      }

      @media only screen and (min-width: 1600px) {
        position: absolute;
        bottom: 0;
        width: 50% !important;
        justify-content: flex-end;


        .banner-description-category {
          font-size: 1.4rem;
          margin-top: 12px;
          line-height: 1.2;
        }

        .banner-description-title {
          font-weight: 400;
          font-size: 2.8rem;
          line-height: 1.3;
        }

        .banner-description-description {
          font-size: 1rem;
          overflow: visible;
        }

        .banner-description-button {
          margin-top: 1.2rem;
          margin-bottom: 1.2rem;

          .v-btn {
            height: 3rem;
          }

          .v-btn__content {
            margin: 0.5rem 1rem;
          }
        }

        .desc-content {
          /*margin-right: 2.3% !important;*/
          width: 78.8% !important;
          position: relative;
          align-items: center;
          justify-content: center;
          background-color: rgba(156, 131, 98, 0.75) !important;
          padding: 5% 0% !important;
        }

        .banner-description-icon {
          width: 100%;
          display: flex !important;
          justify-content: center;
          /*transform: translateY(-170%);*/
        }
      }
    }

    .banner-description {
      height: auto !important;
      font-family: 'Montserrat', "PingFang TC", "Heiti TC", "微軟正黑體", "Microsoft JhengHei", "sans-serif" !important;
      padding: 3% 5%;
      background-color: rgba(142, 118, 91, 1);
      box-shadow: 0 0 10px -5px;

      overflow: visible;
      line-height: 1.2;

      .banner-description-icon {
        display: none;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateY(-50%);
      }

      .banner-description-category {
        color: white;
      }

      .banner-description-title {
        color: white;
      }

      .banner-description-description {
        color: white;
        font-size: 1rem;
        overflow: visible;
      }
    }
  }

  .about-acc-map-container {
    background-color: rgba(239, 239, 239, 1);
    position: relative;

    .map-wrapper {
      height: 60vh;
      width: 60%;
      margin-left: 30%;
      min-height: 450px;

      .map {
        height: 100%;
        width: 100%;

        background-image: url('../assets/map.jpg');
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
      }
    }

    .map-description-wrapper {
      position: absolute;
      top: 0;
      right: 50%;
      width: 50%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .map-description {
        background-color: white;
        padding: 50px;
        width: 80%;
        height: 70%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .map-title {
          font-size: 2rem;
          color: rgb(52, 52, 52);
          padding-bottom: 12px;
        }

        .map-content {
          text-align: center;
          color: rgb(169, 169, 169);
        }
      }

    }


    @media only screen and (max-width: 1200px) {

      padding-bottom: 5rem;

      .map-wrapper {
        width: 100%;
        margin: 0;
        height: 40vh;
        min-height: 350px;
      }

      .map-description-wrapper {
        position: static;
        width: 100%;
        justify-content: center;
        margin-top: -10%;

        .map-description {
          width: 80%;
          padding: 20px;

          .map-title {
            font-size: 1.8rem;
          }

          .map-content {
            font-size: 1.1rem;
          }
        }
      }
    }
  }
}
</style>
